"use client";

import { usePathname } from "next/navigation";
import { useEffect } from "react";

/**
 * Scrolls the window to the top whenever the route (pathname) changes,
 * so every page opens from the very top regardless of the previous scroll.
 */
export default function ScrollToTop() {
  const pathname = usePathname();

  useEffect(() => {
    // `instant` avoids the smooth-scroll animation defined in globals.css
    window.scrollTo({ top: 0, left: 0, behavior: "instant" as ScrollBehavior });
  }, [pathname]);

  return null;
}
